import * as React from 'react'
import { ToggleInput } from './ToggleInput'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const ToggleInputExamples = () => {
  return (
    <div className="ToggleInputExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <ToggleInput />
      </Provider>
    </div>
  )
}
